<template>
    <Modal :title="scheduler.name || ''" width="push-40" section="showSchedulerItem">
        <div class="row mt-0 mb-4" v-if="is_loading">
            <div class="col-12">
                <ShowPageLoading></ShowPageLoading>
            </div>
        </div>
        <div class="row mt-4 mb-4 d-flex justify-content-between" v-else>
            <div class="col-md-5">
                <div class="mt-2 mb-2">
                    <h3 style="border-bottom: 1px solid #ff7516;">Scheduler Activation Data</h3>
                    <ul v-for="(item, index) in scheduler.dataset" v-if="scheduler.dataset">

                        <li class="pb-3" v-if="index === 0 && scheduler.dataset.length === 1">
                            <span v-html="getActivationQueryValue(scheduler)"></span>
                        </li>

                        <li>Analysis Type: <strong>{{ item.analysistype || '' }} </strong></li>

                        <li v-if="item.cohort_name && item.analysistype === 'Cohorts'">Name: {{ item.cohort_name }}</li>

                        <li v-if="item.signalproviders.length"><span v-html="showHideValue('signal-providers', index)" class="toggle-button" @click="toggleShow('signal-providers', index)"></span> {{ item.signalproviders.length }} Signal Providers </li>
                        <ul v-if="item.signalproviders.length" :class="{'hide-toggle' : !showedData.includes('signal-providers_' + index)}">
                            <li v-for="data in item.signalproviders"> {{ data }} </li>
                        </ul>

                        <li v-if="item.categories.length"><span v-html="showHideValue('categories', index)" class="toggle-button" @click="toggleShow('categories', index)"></span> {{ item.categories.length }} Categories</li>
                        <ul v-if="item.categories.length" :class="{'hide-toggle' : !showedData.includes('categories_' + index)}">
                            <li v-for="item in item.categories"> {{ item }} </li>
                        </ul>

                        <li v-if="item.analysisdata.length"><span v-html="showHideValue('analysisdata', index)" class="toggle-button" @click="toggleShow('analysisdata', index)"></span> {{ item.analysisdata.length }} Brands</li>
                        <ul v-if="item.analysisdata.length" :class="{'hide-toggle' : !showedData.includes('analysisdata_' + index)}">
                            <li v-for="item in item.analysisdata"> {{ item }} </li>
                        </ul>

                        <li v-if="item.apps_categories.length && ['Apps'].includes(item.analysistype)"><span v-html="showHideValue('apps_categories', index)" class="toggle-button" @click="toggleShow('apps_categories', index)"></span> {{ item.apps_categories.length }} Categories</li>
                        <ul v-if="item.apps_categories.length && ['Apps'].includes(item.analysistype)" :class="{'hide-toggle' : !showedData.includes('apps_categories_' + index)}">
                            <li v-for="item in item.apps_categories"> {{ item }} </li>
                        </ul>

                        <li v-if="item.apps_tags.length && ['Apps'].includes(item.analysistype)"><span v-html="showHideValue('apps_tags', index)" class="toggle-button" @click="toggleShow('apps_tags', index)"></span> {{ item.apps_tags.length }} Tags</li>
                        <ul v-if="item.apps_tags.length && ['Apps'].includes(item.analysistype)" :class="{'hide-toggle' : !showedData.includes('apps_tags_' + index)}">
                            <li v-for="item in item.apps_tags"> {{ item }} </li>
                        </ul>

                        <li v-if="item.apps_bundle_ids.length && ['Apps'].includes(item.analysistype)"><span v-html="showHideValue('apps_bundle_ids', index)" class="toggle-button" @click="toggleShow('apps_bundle_ids', index)"></span> {{ item.apps_bundle_ids.length }} App Names</li>
                        <ul v-if="item.apps_bundle_ids.length && ['Apps'].includes(item.analysistype)" :class="{'hide-toggle' : !showedData.includes('apps_bundle_ids_' + index)}">
                            <li v-for="item in item.apps_bundle_ids"> {{ item }} </li>
                        </ul>

                        <li v-if="item.apps_device_os.length && ['Apps'].includes(item.analysistype)"><span v-html="showHideValue('apps_device_os', index)" class="toggle-button" @click="toggleShow('apps_device_os', index)"></span> {{ item.apps_device_os.length }} Device OS</li>
                        <ul v-if="item.apps_device_os.length && ['Apps'].includes(item.analysistype)" :class="{'hide-toggle' : !showedData.includes('apps_device_os_' + index)}">
                            <li v-for="item in item.apps_device_os"> {{ item }} </li>
                        </ul>

                        <li v-if="item.locations.length"><span v-html="showHideValue('locations', index)" class="toggle-button" @click="toggleShow('locations', index)"></span> {{ item.locations.length }} Locations</li>
                        <ul v-if="item.locations.length" :class="{'hide-toggle' : !showedData.includes('locations_' + index)}">
                            <li v-for="item in item.locations"> {{ item }} </li>
                        </ul>

                        <li v-if="item.countries.length && ['POI', 'Anonymized', 'Apps'].includes(item.analysistype)"><span v-html="showHideValue('countries', index)" class="toggle-button" @click="toggleShow('countries', index)"></span> {{ item.countries.length }} Countries</li>
                        <ul v-if="item.countries.length && ['POI', 'Anonymized', 'Apps'].includes(item.analysistype)" :class="{'hide-toggle' : !showedData.includes('countries_' + index)}">
                            <li v-for="item in item.countries"> {{ item }} </li>
                        </ul>

                        <li v-if="item.states.length"><span v-html="showHideValue('states', index)" class="toggle-button" @click="toggleShow('states', index)"></span> {{ item.states.length }} States</li>
                        <ul v-if="item.states.length" :class="{'hide-toggle' : !showedData.includes('states_' + index)}">
                            <li v-for="item in item.states"> {{ item }} </li>
                        </ul>

                        <li v-if="item.dmas.length"><span v-html="showHideValue('dmas', index)" class="toggle-button" @click="toggleShow('dmas', index)"></span> {{ item.dmas.length }} DMAs</li>
                        <ul v-if="item.dmas.length" :class="{'hide-toggle' : !showedData.includes('dmas_' + index)}">
                            <li v-for="item in item.dmas"> {{ item }} </li>
                        </ul>

                        <li v-if="item.cities.length"><span v-html="showHideValue('cities', index)" class="toggle-button" @click="toggleShow('cities', index)"></span> {{ item.cities.length }} Cities</li>
                        <ul v-if="item.cities.length" :class="{'hide-toggle' : !showedData.includes('cities_' + index)}">
                            <li v-for="item in item.cities"> {{ item }} </li>
                        </ul>

                        <li v-if="item.zipcodes.length"><span v-html="showHideValue('zipcodes', index)" class="toggle-button" @click="toggleShow('zipcodes', index)"></span> {{ item.zipcodes.length }} Zip Codes</li>
                        <ul v-if="item.zipcodes.length" :class="{'hide-toggle' : !showedData.includes('zipcodes_' + index)}">
                            <li v-for="item in item.zipcodes"> {{ item }} </li>
                        </ul>

                        <li v-if="item.limits && ((item.limits.time && item.limits.time.process) || (item.limits.distance && item.limits.distance.process))"><span v-html="showHideValue('limits', index)" class="toggle-button" @click="toggleShow('limits', index)"></span> Limits</li>
                        <ul v-if="item.limits && ((item.limits.time && item.limits.time.process) || (item.limits.distance && item.limits.distance.process))" :class="{'hide-toggle' : !showedData.includes('limits_' + index)}">
                            <li v-if="item.limits.time && item.limits.time.process"><strong>Time:</strong> {{ item.limits.time.start.toString().padStart(2, '0') }}:00 - {{ item.limits.time.end.toString().padStart(2, '0') }}:59</li>
                            <li v-if="item.limits.distance && item.limits.distance.process"><strong>Distance:</strong> {{ item.limits.distance.distance }} {{ item.limits.distance.unit }} </li>
                        </ul>

                        <li class="mt-3" v-if="['Anonymized'].includes(item.analysistype) && item.selectedFields"><strong>Selected Fields:</strong></li>

                        <li v-if="['Anonymized'].includes(item.analysistype) && item.selectedFields && item.selectedFields.geoLocation">
                            <span v-html="showHideValue('geo', index)" class="toggle-button" @click="toggleShow('geo', index)"></span>
                            {{ item.selectedFields.geoLocation.length }} Geo Location
                        </li>
                        <ul v-if="['Anonymized'].includes(item.analysistype) && item.selectedFields && item.selectedFields.geoLocation" :class="{'hide-toggle' : !showedData.includes('geo_' + index)}">
                            <li v-for="item in item.selectedFields.geoLocation"> {{ item }} </li>
                        </ul>

                        <li v-if="['Anonymized'].includes(item.analysistype) && item.selectedFields && item.selectedFields.Advertising">
                            <span v-html="showHideValue('advertising', index)" class="toggle-button" @click="toggleShow('advertising', index)"></span>
                            {{ item.selectedFields.Advertising.length }} Advertising
                        </li>
                        <ul v-if="['Anonymized'].includes(item.analysistype) && item.selectedFields && item.selectedFields.Advertising" :class="{'hide-toggle' : !showedData.includes('advertising_' + index)}">
                            <li v-for="item in item.selectedFields.Advertising"> {{ item }} </li>
                        </ul>

                        <li v-if="['Anonymized'].includes(item.analysistype) && item.selectedFields && item.selectedFields.userDetails">
                            <span v-html="showHideValue('user_details', index)" class="toggle-button" @click="toggleShow('user_details', index)"></span>
                            {{ item.selectedFields.userDetails.length }} User Details
                        </li>
                        <ul v-if="['Anonymized'].includes(item.analysistype) && item.selectedFields && item.selectedFields.userDetails" :class="{'hide-toggle' : !showedData.includes('user_details_' + index)}">
                            <li v-for="item in item.selectedFields.userDetails"> {{ item }} </li>
                        </ul>

                        <li v-if="['Anonymized'].includes(item.analysistype) && item.selectedFields && item.selectedFields.ipDetails">
                            <span v-html="showHideValue('ip_details', index)" class="toggle-button" @click="toggleShow('ip_details', index)"></span>
                            {{ item.selectedFields.ipDetails.length }} IP Details
                        </li>
                        <ul v-if="['Anonymized'].includes(item.analysistype) && item.selectedFields && item.selectedFields.ipDetails" :class="{'hide-toggle' : !showedData.includes('ip_details_' + index)}">
                            <li v-for="item in item.selectedFields.ipDetails"> {{ item }} </li>
                        </ul>

                        <li v-if="['Anonymized'].includes(item.analysistype) && item.selectedFields && item.selectedFields.privacy">
                            <span v-html="showHideValue('privacy', index)" class="toggle-button" @click="toggleShow('privacy', index)"></span>
                            {{ item.selectedFields.privacy.length }} Privacy
                        </li>
                        <ul v-if="['Anonymized'].includes(item.analysistype) && item.selectedFields && item.selectedFields.privacy" :class="{'hide-toggle' : !showedData.includes('privacy_' + index)}">
                            <li v-for="item in item.selectedFields.privacy"> {{ item }} </li>
                        </ul>

                        <li class="mt-3" v-if="index === 0 && scheduler.dataset.length > 1">
                            <span v-html="getActivationQueryValue(scheduler)"></span>
                        </li>
                    </ul>
                </div>

                <div class="mt-4 mb-2" v-if="scheduler.analyses && scheduler.analyses.crossvisitation && scheduler.analyses.crossvisitation.process">
                    <h3 style="border-bottom: 1px solid #ff7516;">Cross Visitation Analysis</h3>
                    <div class="row mt-3">
                        <ul class="col-12 mb-0 py-0 mt-1 pl-5 list-unstyled" v-if="scheduler.analyses.crossvisitation.categories.length">
                            <li><span v-html="showHideValue('cross-categories', 5)" class="toggle-button" @click="toggleShow('cross-categories', 5)"></span> {{ scheduler.analyses.crossvisitation.categories.length }} Categories</li>
                            <ul v-if="scheduler.analyses.crossvisitation.categories" :class="{'hide-toggle' : !showedData.includes('cross-categories_' + 5)}">
                                <li v-for="data in scheduler.analyses.crossvisitation.categories"> {{ data }} </li>
                            </ul>
                        </ul>
                        <ul class="col-12 mb-0 py-0 mt-1 pl-5 list-unstyled" v-if="scheduler.analyses.crossvisitation.brands.length">
                            <li><span v-html="showHideValue('cross-brands', 5)" class="toggle-button" @click="toggleShow('cross-brands', 5)"></span> {{ scheduler.analyses.crossvisitation.brands.length }} Brands</li>
                            <ul v-if="scheduler.analyses.crossvisitation.brands" :class="{'hide-toggle' : !showedData.includes('cross-brands_' + 5)}">
                                <li v-for="data in scheduler.analyses.crossvisitation.brands"> {{ data }} </li>
                            </ul>
                        </ul>
                        <ul class="col-12 mb-0 py-0 mt-1 pl-5 list-unstyled" v-if="scheduler.analyses.crossvisitation.locations && scheduler.analyses.crossvisitation.locations.length">
                            <li><span v-html="showHideValue('cross-locations', 5)" class="toggle-button" @click="toggleShow('cross-locations', 5)"></span> {{ scheduler.analyses.crossvisitation.locations.length }} Locations</li>
                            <ul v-if="scheduler.analyses.crossvisitation.locations" :class="{'hide-toggle' : !showedData.includes('cross-locations_' + 5)}">
                                <li v-for="data in scheduler.analyses.crossvisitation.locations"> {{ data }} </li>
                            </ul>
                        </ul>
                        <div v-if="scheduler.analyses.crossvisitation.location">
                            <ul class="col-12 mb-0 py-0 mt-1 pl-5 list-unstyled" v-if="scheduler.analyses.crossvisitation.location.countries.length">
                                <li><span v-html="showHideValue('cross-countries', 5)" class="toggle-button" @click="toggleShow('cross-countries', 5)"></span> {{ scheduler.analyses.crossvisitation.location.countries.length }} Countries</li>
                                <ul v-if="scheduler.analyses.crossvisitation.location.countries" :class="{'hide-toggle' : !showedData.includes('cross-countries_' + 5)}">
                                    <li v-for="data in scheduler.analyses.crossvisitation.location.countries"> {{ data }} </li>
                                </ul>
                            </ul>
                            <ul class="col-12 mb-0 py-0 mt-1 pl-5 list-unstyled" v-if="scheduler.analyses.crossvisitation.location.states.length">
                                <li><span v-html="showHideValue('cross-states', 5)" class="toggle-button" @click="toggleShow('cross-states', 5)"></span> {{ scheduler.analyses.crossvisitation.location.states.length }} States</li>
                                <ul v-if="scheduler.analyses.crossvisitation.location.states" :class="{'hide-toggle' : !showedData.includes('cross-states_' + 5)}">
                                    <li v-for="data in scheduler.analyses.crossvisitation.location.states"> {{ data }} </li>
                                </ul>
                            </ul>
                            <ul class="col-12 mb-0 py-0 mt-1 pl-5 list-unstyled" v-if="scheduler.analyses.crossvisitation.location.cities.length">
                                <li><span v-html="showHideValue('cross-cities', 5)" class="toggle-button" @click="toggleShow('cross-cities', 5)"></span> {{ scheduler.analyses.crossvisitation.location.cities.length }} Cities</li>
                                <ul v-if="scheduler.analyses.crossvisitation.location.cities" :class="{'hide-toggle' : !showedData.includes('cross-cities_' + 5)}">
                                    <li v-for="data in scheduler.analyses.crossvisitation.location.cities"> {{ data }} </li>
                                </ul>
                            </ul>
                            <ul class="col-12 mb-0 py-0 mt-1 pl-5 list-unstyled" v-if="scheduler.analyses.crossvisitation.location.dmas.length">
                                <li><span v-html="showHideValue('cross-dmas', 5)" class="toggle-button" @click="toggleShow('cross-dmas', 5)"></span> {{ scheduler.analyses.crossvisitation.location.dmas.length }} DMAs</li>
                                <ul v-if="scheduler.analyses.crossvisitation.location.dmas" :class="{'hide-toggle' : !showedData.includes('cross-dmas_' + 5)}">
                                    <li v-for="data in scheduler.analyses.crossvisitation.location.dmas"> {{ data }} </li>
                                </ul>
                            </ul>
                            <ul class="col-12 mb-0 py-0 mt-1 pl-5 list-unstyled" v-if="scheduler.analyses.crossvisitation.location.zipcodes.length">
                                <li><span v-html="showHideValue('cross-zipcodes', 5)" class="toggle-button" @click="toggleShow('cross-zipcodes', 5)"></span> {{ scheduler.analyses.crossvisitation.location.zipcodes.length }} Zipcodes</li>
                                <ul v-if="scheduler.analyses.crossvisitation.location.zipcodes" :class="{'hide-toggle' : !showedData.includes('cross-zipcodes_' + 5)}">
                                    <li v-for="data in scheduler.analyses.crossvisitation.location.zipcodes"> {{ data }} </li>
                                </ul>
                            </ul>
                        </div>
                        <ul class="col-12 mb-0 py-0 mt-1 pl-5 list-unstyled" v-if="scheduler.analyses.crossvisitation.limits && ((scheduler.analyses.crossvisitation.limits.time && scheduler.analyses.crossvisitation.limits.time.process) || (scheduler.analyses.crossvisitation.limits.distance && scheduler.analyses.crossvisitation.limits.distance.process))">
                            <li><span v-html="showHideValue('cross-limits', 5)" class="toggle-button" @click="toggleShow('cross-limits', 5)"></span> Limits</li>
                            <ul :class="{'hide-toggle' : !showedData.includes('cross-limits_' + 5)}">
                                <li v-if="scheduler.analyses.crossvisitation.limits.time && scheduler.analyses.crossvisitation.limits.time.process"><strong>Time:</strong> {{ scheduler.analyses.crossvisitation.limits.time.start.toString().padStart(2, '0') }}:00 - {{ scheduler.analyses.crossvisitation.limits.time.end.toString().padStart(2, '0') }}:59</li>
                                <li v-if="scheduler.analyses.crossvisitation.limits.distance && scheduler.analyses.crossvisitation.limits.distance.process"><strong>Distance:</strong> {{ scheduler.analyses.crossvisitation.limits.distance.distance }} {{ scheduler.analyses.crossvisitation.limits.distance.unit }} </li>
                            </ul>
                        </ul>
                        <ul class="col-12 mb-0 py-0 mt-1 pl-5 list-unstyled" v-if="scheduler.analyses.crossvisitation.filters">
                            <li><span v-html="showHideValue('cross-filters', 5)" class="toggle-button" @click="toggleShow('cross-filters', 5)"></span> Filters</li>
                            <ul v-if="scheduler.analyses.crossvisitation.filters" :class="{'hide-toggle' : !showedData.includes('cross-filters_' + 5)}">
                                <li v-for="data in scheduler.analyses.crossvisitation.filters"> {{ data }} </li>
                            </ul>
                        </ul>
                    </div>
                </div>

            </div>
            <div class="col-md-6">
                <div class="mt-2 mb-2">
                    <h3 style="border-bottom: 1px solid #ff7516;">Audience Details</h3>
                    <div class="row mt-3 mb-1">
                        <div class="form-inline col-md-4 py-0"><strong> Audience Name: </strong> </div>
                        <div class="form-inline col-md-8 py-0"> {{ scheduler.name || '' }} </div>
                    </div>
                    <div class="row mt-0 mb-1" v-if="(scheduler.dataset && scheduler.dataset[0] && scheduler.dataset[0].analysistype !== 'Anonymized')">
                        <div class="form-inline col-md-4 py-0 align-self-start"><strong> Analyses: </strong> </div>
                        <div class="form-inline col-md-8 py-0">
                            <ul class="mb-0" style="list-style:none;padding-left:0;">
                                <li>Audience</li>
                                <li v-for="(analyse, index) in scheduler.analyses" v-if="scheduler.analyses && analyse.process">
                                    {{ analyse.name || '' }}
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="row mt-6" v-if="scheduler.filters">
                        <div class="form-inline col-md-4 py-0 align-self-start"><strong> Filters: </strong> </div>
                        <div class="form-inline col-md-8 py-0">
                            <ul class="mb-0" style="list-style:none;padding-left:0;">
                                <li v-for="filter in scheduler.filters" v-if="scheduler.filters">
                                    {{ filter || '' }}
                                </li>
                            </ul>

                        </div>
                    </div>
                </div>

                <div class="mt-4 mb-2" v-if="scheduler.recurrences">
                    <h3 style="border-bottom: 1px solid #ff7516;">Scheduler Info</h3>
                    <div class="row mt-3 mb-1">
                        <div class="form-inline col-md-4 py-0"><strong> Recurrence: </strong> </div>
                        <div class="form-inline col-md-8 py-0">
                            <span class="d-block">
                                <span v-if="scheduler.recurrences && scheduler.recurrences.frequency === 'daily'">Every day</span>
                                <span v-if="scheduler.recurrences && scheduler.recurrences.frequency === 'weekly'">Every {{ days[new Date(scheduler.recurrences.start).getDay()] }}</span>
                                <span v-if="scheduler.recurrences && scheduler.recurrences.frequency === 'bi-weekly'">Bi-Weekly on {{ days[new Date(scheduler.recurrences.start).getDay()] }}</span>
                                <span v-if="scheduler.recurrences && scheduler.recurrences.frequency === 'monthly'">Every {{ new Date(scheduler.recurrences.start).getDate() }}{{ nthDate(new Date(scheduler.recurrences.start).getDate()) }} of a month</span>
                            </span>
                        </div>
                    </div>
                    <div class="row mt-0 mb-1">
                        <div class="form-inline col-md-4 py-0"><strong> Duration: </strong> </div>
                        <div class="form-inline col-md-8 py-0"> {{ scheduler.recurrences.recurrence_type }} </div>
                    </div>
                    <div class="row mt-0 mb-1">
                        <div class="form-inline col-md-4 py-0"><strong> Expiry: </strong> </div>
                        <div class="form-inline col-md-8 py-0"> {{ scheduler.recurrences.expiry }} </div>
                    </div>
                    <div class="row mt-0 mb-1">
                        <div class="form-inline col-md-4 py-0"><strong> Next Run: </strong> </div>
                        <div class="form-inline col-md-8 py-0">
                            {{ scheduler.recurrences.next_run_time }}
                            <small class="ml-1">({{ scheduler.recurrences.timezone }})</small>
                        </div>
                    </div>
                </div>

                <div class="mt-4 mb-2" v-if="scheduler.recurrences">
                    <h3 style="border-bottom: 1px solid #ff7516;">Scheduler Recency</h3>
                    <div class="row mt-3 mb-1">
                        <div class="form-inline col-md-4 py-0"><strong> Latest Analysis: </strong> </div>
                        <div class="form-inline col-md-8 py-0"> {{ scheduler.recurrences.last_run }} </div>
                    </div>
                    <div class="row mt-0 mb-1">
                        <div class="form-inline col-md-4 py-0"><strong> Next Analysis: </strong> </div>
                        <div class="form-inline col-md-8 py-0"> {{ scheduler.recurrences.next_run }} </div>
                    </div>
                    <div class="row mt-0 mb-1">
                        <div class="form-inline col-md-4 py-0"><strong> Total Analyses: </strong> </div>
                        <div class="form-inline col-md-8 py-0">
                            <span>{{ scheduler.recurrences.cycles_done }}</span><span class="mx-1">/</span><span v-if="scheduler.recurrences.cycles_available != 0">{{ scheduler.recurrences.cycles_available }}</span>
                            <span v-if="scheduler.recurrences.cycles_available == 0">&infin;</span>
                        </div>
                    </div>
                </div>

                <div class="mt-4 mb-2" v-if="scheduler.activation && Object.keys(scheduler.activation).length">
                    <h3 style="border-bottom: 1px solid #ff7516;">Activation Details</h3>
                    <div class="row mt-3 mb-1">
                        <div class="form-inline col-md-4 py-0"><strong> Endpoint: </strong> </div>
                        <div class="form-inline col-md-8 py-0"> {{ scheduler.activation.partner_name || '' }} </div>
                    </div>

                    <div class="row mt-0 mb-1" v-for="(endpoint, index) in scheduler.activation.endpoint" v-if="(index !== 'partner_name' && !['datastreams', 'account_credentials', 'pricing_model_id', 'pricing_model'].includes(index))">
                        <div class="form-inline col-md-4 py-0"><strong style="text-transform: capitalize;">{{ index.replace('_', ' ') }}: </strong> </div>
                        <div class="form-inline col-md-8 py-0"> {{ endpoint }} </div>
                    </div>

                    <div class="row mt-0 mb-1">
                        <div class="form-inline col-md-4 py-0"><strong> Pricing Model: </strong> </div>
                        <div class="form-inline col-md-8 py-0"> {{ scheduler.activation.pricing_model || '' }} </div>
                    </div>
                    <div class="row mt-0 mb-1">
                        <div class="form-inline col-md-4 py-0"><strong> Limit: </strong> </div>
                        <div class="form-inline col-md-8 py-0">
                            {{ scheduler.activation.limit ? new Intl.NumberFormat().format(scheduler.activation.limit) : 'Unlimited' }}
                            {{ getIdentifierByPricingModel(scheduler.activation.pricing_model) }}s
                        </div>
                    </div>
                    <div class="row mt-0 mb-1">
                        <div class="form-inline col-md-4 py-0"><strong> Price per {{ getIdentifierByPricingModel(scheduler.activation.pricing_model) }}: </strong> </div>
                        <div class="form-inline col-md-8 py-0"> ${{ scheduler.activation.price }} </div>
                    </div>
                    <div class="row mt-3 mb-2" v-if="scheduler.activation.compression">
                        <div class="form-inline col-md-4 py-0"><strong> Compression Type: </strong> </div>
                        <div class="form-inline col-md-8 py-0"> {{ scheduler.activation.compression === 'csv' ? 'CSV Uncompressed' : 'GZIP Compression' }} </div>
                    </div>
                    <div class="row mt-0 mb-1" v-if="scheduler.activation.dataStreams && scheduler.activation.dataStreams.length">
                        <div class="form-inline col-md-4 py-0"><strong> DataStreams: </strong> </div>
                        <div class="form-inline col-md-8 py-0">
                            <ul class="mb-0" style="list-style:none;padding-left:0;">
                                <li v-for="(dataStream, index) in scheduler.activation.dataStreams">
                                    {{ dataStream || '' }}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="mt-4 mb-2">
                    <h3 style="border-bottom: 1px solid #ff7516;">Scheduler Properties</h3>
                    <div class="row mt-3 mb-1">
                        <div class="form-inline col-md-4 py-0"><strong> Status: </strong> </div>
                        <div class="form-inline col-md-8 py-0">
                            <span class="badge" :class="getBadgeStatusClassName(scheduler.status_color)">{{ scheduler.string_status }}</span>
                        </div>
                    </div>
                    <div class="row mt-0 mb-1">
                        <div class="form-inline col-md-4 py-0"><strong> Created at: </strong> </div>
                        <div class="form-inline col-md-8 py-0"> {{ scheduler.created_at || '' }} </div>
                    </div>
                    <div class="row mt-0 mb-1">
                        <div class="form-inline col-md-4 py-0"><strong> Created by: </strong> </div>
                        <div class="form-inline col-md-8 py-0"> {{ scheduler.user || 'Default' }} | {{ scheduler.company || 'Default' }}</div>
                    </div>
                </div>

            </div>
            <!--form-group-->
        </div>
    </Modal>
</template>

<script>
import Modal from '../Modal'
import api from "../../api/analyses/scheduler";
import mixins from "../../mixin";
import ShowPageLoading from "../general/ShowPageLoading.vue";
export default {
    name: "ShowSchedulerItem",
    mixins: [mixins],
    components: {
        ShowPageLoading,
        Modal
    },
    data: () => ({
        scheduler: [],
        is_loading: true,

        showedData: [],

        days: [
            'Sunday',
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday'
        ],
    }),
    methods: {
        async fetchScheduler() {
            await api.getSingleScheduler({
                scheduler: this.$parent.showingScheduler
            })
            .then(res => {
                if (res.status === 202) {
                    this.$toast.open({
                        message: 'This scheduler item was removed.',
                        type: "error",
                    })
                    this.$parent.showSchedulerItem = false
                    this.$parent.showingScheduler = ''
                    window.history.pushState({}, null, window.location.href.split('/').splice(0, 6).join('/'));
                }
                this.scheduler = res.data.scheduler

                this.is_loading = false
            })
        },
    },
    mounted() {
        this.fetchScheduler()
    }
}
</script>

<style scoped>

</style>